<template>
    <div class="container">
        <el-form >
            <el-form-item label="生成注册码">
                <el-switch v-model="delivery"></el-switch>
            </el-form-item>

            <el-form-item label="注册码：">
                <el-input style="width:30%;" placeholder="请牢记此处注册码" v-model="code" :disabled="true"></el-input>
                <el-button type="success" @click="onSubmit">生成注册码</el-button>
                <el-button type="warning" class="btn" @click="copy" :data-clipboard-text='code'>复制注册码</el-button>
            </el-form-item>
            <el-form-item>
            </el-form-item>
            <el-form-item label="推荐人：">
                <el-select v-model="phone" filterable placeholder="请选择" style="width:30%;">
                    <el-option
                            v-for="item in options"
                            :key="item.index"
                            :label="item.name+item.mobileNumber"
                            :value="item.mobileNumber + '@' + item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 68px;">
                <el-button type="primary" @click="send">发送验证码到手机</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<style scoped>
    .container {
        margin-left: 18px;
    }
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
</style>
<script>
  import Clipboard from 'clipboard';

  export default {
    data() {
      return {
        delivery: true,
        code: '',
        phone: '',
        options: []
      }
    },
    mounted: function () {
      this.getinfo()
    },
    methods: {
      getinfo: function () {
        let rolename = {rolename: '患者'}
        this.$axios({
          url: '/api/user/usersByRolename',
          method: 'GET',
          params: rolename
        }).then(res => {
          this.options = res.data.data
        })
      },
      send: function () {
//          alert(this.phone);
          let phone = this.phone.split('@')[0];
          let userid = this.phone.split('@')[1];
          let code = this.code;
          if(code == undefined || code == ''){
              this.$message({
                  message: "注册码不能为空！",
                  type: 'warning'
              });
              return;
          }
          let params = {phone: phone, registrationCode: code};
          this.$axios({
              url: "/api/sys/smslog/sendSmsRegistrationCode",
              method: "POST",
              data: params
          }).then(res => {
              if (res.data.code == 0) {
                  this.$axios({
                      url: "/api/code/" + code + "/" + userid,
                      method: "PUT",
                  }).then(res =>{
                      this.$message({
                          message: '短信发送成功！',
                          type: 'success'
                      });
                  })
              } else {
                  this.$message({
                      message: "短信发送失败，请联系管理员！",
                      type: 'warning'
                  });
              }
          }).catch(err => {
              this.$message({
                  message: '系统错误，请联系管理员！',
                  type: 'danger'
              });
          });
      },
      onSubmit() {
        if (this.delivery) {
          this.$axios({
            url: "/api/code/produceCode",
            method: "GET"
          }).then(res => {
            if (res.data.code == 200) {
              this.code = res.data.data;
              this.$message({
                message: '注册码创建成功！',
                type: 'success'
              });
            } else {
              this.$message({
                message: '很抱歉，注册码创建失败。',
                type: 'warning'
              });
            }
          }).catch(err => {
            console.log(err);
          });
        } else {
          this.$message({
            message: '请选择生成注册码。',
            type: 'warning'
          });
          return;
        }
      },
      copy() {
        let thCode = this.code;
        if (thCode != '') {
          let clipboard = new Clipboard('.btn');           //可通过任意选择器进行实例化
          clipboard.on('success', (e) => {           //使用on绑定成功
            this.$message({
              message: '复制成功',
              type: 'success'
            });
            clipboard.destroy();
          });
          clipboard.on('error', function (e) {             //使用on绑定失败
            clipboard.destroy();
          });
        } else {
          this.$message({
            message: '信息为空无法复制',
            type: 'warning'
          });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// createCode.vue?485f0704